import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import EditIcon from "@material-ui/icons/Edit";
import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import AddStaffAttendance from "../AddStaffAttendance/AddStaffAttendance";

class StaffAttendanceBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      attendanceId: "",
    };
  }

  handleEditStatus = () => {
    this.setState({
      editStatus: true,
      attendanceId: this.props.data.attendanceId
        ? this.props.data.attendanceId
        : "",
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  render() {
    const { classes, index, data } = this.props;
    return this.state.editStatus === false ? (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.staffId.fullName}</TableCell>
        <TableCell align="center">{data.staffId.department}</TableCell>
        <TableCell align="center">{data.staffId.designation}</TableCell>

        {data.status === "P" && (
          <TableCell
            align="center"
            style={{ color: "green", fontWeight: "bold" }}
          >
            Present
          </TableCell>
        )}
        {data.status === "A" && (
          <TableCell
            align="center"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Absent
          </TableCell>
        )}
        {data.status === "L" && (
          <TableCell
            align="center"
            style={{ color: "orange", fontWeight: "bold" }}
          >
            Leave
          </TableCell>
        )}
        {data.status === "" && <TableCell align="center">N/A</TableCell>}
        <TableCell align="center">
          {data.remarks ? data.remarks : "N/A"}
        </TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Set Attendance"
            className={classes.tooltip}
            onClick={this.handleEditStatus}
          >
            <EditIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    ) : (
      <AddStaffAttendance
        editStatus={true}
        data={data}
        attendanceId={this.state.attendanceId}
        handleCancelEdit={this.handleCancelEdit}
        getStaffAttendance={this.props.getStaffAttendance}
      />
    );
  }
}

export default withStyles(useStyles)(StaffAttendanceBody);
